module.exports = __webpack_public_path__ + "3c7ef460.svg";